import React, { useRef, useState } from 'react'
import { PiSmiley } from 'react-icons/pi'
import EmojiPicker, { EmojiClickData } from 'emoji-picker-react'
import { useOutsideClick } from '../../../_common/hook/useOutsideClick'

interface Props {
    onSelect: (msg: any) => void
    inputRef: any
}

const EmojiPickerButton: React.FC<Props> = ({ onSelect, inputRef }) => {
    const [showEmoji, setShowEmoji] = useState(false)
    const emojiRef = useRef<HTMLDivElement>(null)

    useOutsideClick(emojiRef, () => setShowEmoji(false))

    const onEmojiClick = (emojiData: EmojiClickData) => {
        const input = inputRef.current
        if (!input) return

        const message: any = inputRef.current.value

        const start = input.selectionStart ?? message.length
        const end = input.selectionEnd ?? message.length

        const newValue = message.substring(0, start) + emojiData.emoji + message.substring(end)
        onSelect(newValue)
    }

    return (
        <>
            <button
                type="button"
                className={`
                     bg-white text-[#222222] border border-[#CBD5E1] rounded-full transition w-8 h-8 flex items-center justify-center
                     hover:bg-primary hover:border-primary
                `}
                onClick={() => setShowEmoji((p) => !p)}
            >
                <PiSmiley className="text-[1.5rem]" />
            </button>
            {showEmoji && (
                <div className="absolute bottom-20 right-0 z-10" ref={emojiRef}>
                    <EmojiPicker onEmojiClick={onEmojiClick} />
                </div>
            )}
        </>
    )
}

export default EmojiPickerButton
